import React, {Component, Fragment} from 'react';
import {get} from 'lodash';
import ReactHtmlParser from 'react-html-parser';
import GuestOrderInput from '../../../../components/common/Formik/GuestOrderInput';
import NumberFormatInput from '../../../../components/common/Formik/NumberFormatInput';
import isEmpty from "../../../../utils/helpers";
import {trans} from "../../../../utils/helpers";

class CustomerInfoStep extends Component {
    componentDidMount() {
        const {setTouched} = this.props;
        setTouched({});
    }

    render() {
        const {
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            setFieldValue,
            createAccountAndOrderLoader,
            createAccountAndOrderError,
            handleChangeStep,
            newAccountInfoData
        } = this.props;

        const editMode = !isEmpty(newAccountInfoData);

		return (
			<div className="form-section" id="fs5">

				<h4>{trans('en-us', 'guestOrderScreen.contactInfo.title')}</h4>
				<p><i className="fas fa-map-marker-alt" /> {values.formatedAddress}</p>
				<p className="text-center text-xs text-muted d-block d-sm-none">Scroll down to see map</p>

				<div className="form-row">

					<GuestOrderInput
						type="text"
						label="First Name"
						name="account.accountHolder.firstName"
						size="col col-sm-6"
						errors={errors}
						value={values.account.accountHolder.firstName}
						touched={touched}
						onChange={(e) =>
							setFieldValue('account.accountHolder.firstName', e.target.value.replace(/[^a-z\-A-Z\s']/g, ''))}
						onBlur={handleBlur}
						isDisabled={editMode}
					/>

					<GuestOrderInput
						type="text"
						label="Last Name"
						name="account.accountHolder.lastName"
						size="col col-sm-6"
						errors={errors}
						value={values.account.accountHolder.lastName}
						touched={touched}
						onChange={(e) =>
							setFieldValue('account.accountHolder.lastName', e.target.value.replace(/[^a-z\-A-Z\s']/g, ''))}
						onBlur={handleBlur}
						isDisabled={editMode}
					/>

				</div>

				<GuestOrderInput
					type="text"
					label="Email"
					name="account.accountHolder.personalEmail"
					size=""
					errors={errors}
					value={values.account.accountHolder.personalEmail}
					touched={touched}
					onChange={handleChange}
					onBlur={handleBlur}
				/>

				<NumberFormatInput
					type="text"
					label="Mobile Phone (optional)"
					name="account.accountHolder.mobileNumber.number"
					size=""
					errors={errors}
					value={values.account.accountHolder.mobileNumber.number}
					touched={touched}
					onChange={(e) =>
						setFieldValue(
							'account.accountHolder.mobileNumber.number',
							e.target.value.replace(/[()+,' '-]/g, '')
						)}
					onBlur={handleBlur}
					isDisabled={editMode}
				/>

                {!editMode && (
                    <Fragment>
						<p className="text-xs">{trans('en-us', 'guestOrderScreen.contactInfo.termsAndCondition')}</p>
						<div className="form-group custom-checkbox">
							<input
								type="checkbox"
								className="custom-control-input"
								id="agree-tc"
								name="account.termsAndCondition"
								checked={editMode? true: values.account.termsAndCondition}
								onChange={(e) => setFieldValue('account.termsAndCondition', e.target.checked)}
								onBlur={handleBlur}
								disabled={editMode}
							/>
							<label className="custom-control-label" htmlFor="agree-tc">
								{ReactHtmlParser(
									trans('en-us', 'termsAndConditionsLink')
								)}
							</label>
							{get(errors, `account.termsAndCondition`) &&
								get(touched, `account.termsAndCondition`) && (
									<div style={{display: 'block'}} className="invalid-feedback">
										{get(errors, `account.termsAndCondition`)}
									</div>
								)}
						</div>
                    </Fragment>
                )}

				{createAccountAndOrderError && <p style={{ color: 'red' }}>{createAccountAndOrderError}</p>}

				<div className="form-group form-group-footer">
					<button
						onClick={() => handleChangeStep(editMode? 'verify-email': 'packages-and-products')}
						type="button"
						id=""
						className="btn btn-quick"
						data-target="fs5"
					>
						Back
					</button>
					<button
						disabled={createAccountAndOrderLoader}
						type="submit"
						id=""
						className="btn btn-primary"
						data-target="fs7"
					>
						Submit {createAccountAndOrderLoader && <i className="fas fa-fw fa-spin fa-spinner" />}
					</button>
				</div>

			</div>
		);
	}
}

export default CustomerInfoStep;
